import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { RegisterPayload } from '../auth.types';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, TranslatePipe],
  templateUrl: './register.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent {
  form!: FormGroup;
  apiError: string | null = null;
  loading = false;
  showPassword = false;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router
  ) {
    // Champs requis : lastName, firstName, email, password, orgName, establishmentName
    this.form = this.fb.group({
      lastName: ['', [Validators.required, Validators.maxLength(60)]],
      firstName: ['', [Validators.required, Validators.maxLength(60)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(120)]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(200)]],
      orgName: ['', [Validators.required, Validators.maxLength(100)]],
      establishmentName: ['', [Validators.required, Validators.maxLength(100)]],
    });
  }

  submit() {
    this.apiError = null;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    
    if (this.loading) return;
    this.loading = true;

    const raw = this.form.getRawValue();
    const body: RegisterPayload = {
      lastName: raw.lastName?.trim(),
      firstName: raw.firstName?.trim(),
      email: raw.email?.trim(),
      password: raw.password,
      orgName: raw.orgName?.trim(),
      establishmentName: raw.establishmentName?.trim(),
      queueName: 'File principale',
      timezone: 'Europe/Paris',
      address: '',
    };

    this.auth.register(body).subscribe({
      next: () => {
        this.loading = false;
        this.router.navigateByUrl('/');
      },
      error: (err) => {
        this.loading = false;
        this.apiError = err?.error?.message ?? 'Impossible de créer le compte.';
      },
    });
  }

  cancel() {
    this.router.navigateByUrl('/login');
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
